<!--
  CompanySelectModal.vue
  会社選択モーダル
-->
<template>
  <ModalBase
    :title="'会社選択'"
    :isShowModal="isShowModal"
    :canCancel="true"
    :close="modalClose"
    :width="'550px'"
    :height="'200px'"
  >
    <div class="card -card">
      <!-- 会社選択プルダウン -->
      <select class="company-select" v-model="selectedCompanyHash">
        <option
          v-for="(company, companyIndex) in companyList"
          :key="company.comapny_hash + '_' + companyIndex"
          :value="company.comapny_hash"
        >
          {{ company.comapny_name }}
        </option>
      </select>
      <!-- 選択ボタン -->
      <button class="selected button is-small" @click="selectCompany()">
        選択
      </button>
    </div>
  </ModalBase>
</template>

<script>
// モーダルベース
import ModalBase from '@/hrm-frontend/views/atomic/screen-components/basic-components/base-modal/ModalBase'

export default {
  name: 'CompanySelectModal',
  componentName: 'CompanySelectModal',
  components: {
    // モーダルベース
    ModalBase,
  },
  props: {
    /**
     * モーダル表示フラグ
     * @type {Boolean}
     */
    isShowModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    /**
     * 会社一覧
     * @type {Object}
     */
    companyList: {
      type: Object,
      required: true,
    },
    /**
     * 選択結果
     * @type {Function}
     */
    selectedCompany: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      /**
       * モーダル表示フラグ
       * @type {Boolean}
       */
      isShowModalSync: this.isShowModal,
      /**
       * 選択会社ID
       * @type {Boolean}
       */
      selectedCompanyHash: '',
    }
  },
  watch: {
    /**
     * モーダル表示
     */
    isShowModal() {
      this.isShowModalSync = this.isShowModal
    },
  },
  methods: {
    /**
     * モーダルクローズ
     */
    modalClose () {
      isShowModal = false
    },
    /**
     * 会社選択
     */
    selectCompany () {
      this.selectedCompany(selectedCompanyHash)
    }
  }
}
</script>

<style lang="scss" scoped>
// モーダル
.-card {
  width: 550px;
  height: 300px;
}
// 会社一覧プルダウン
.company-select {
  width: 200px;
  height: 30px;
}
// 選択ボタン
.selected {
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/hrm-frontend/views/atomic/screen-components/purpose_components/common-components/CompanySelectModal.vue